import React, {useState} from "react";
import "./Backup.css";
import Button from "react-bootstrap/Button";
import {ProgressBar} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCloudArrowUp, faSpinner
} from "@fortawesome/free-solid-svg-icons";
import {sleep} from "../../../../lib/utils";
import {faClone} from "@fortawesome/free-regular-svg-icons";
import config from "../../../../config";


function Backup({bond, backupApi, onUploadDone}) {
    const [backupStarted, setBackupStarted] = useState(false);
    const [backupProgress, setBackupProgress] = useState(0);
    const [backupError, setBackupError] = useState('');

    async function startBackup() {
        setBackupProgress(2);
        setBackupStarted(true);
        setBackupError('');

        const backupServerPath = `/backup/${bond.id}/`;
        const response = await bond.put("/sys/backup", {
            "host": config.backup.hostIp || backupApi.host,
            "http_port": `${config.backup.hostPort || backupApi.port}`,
            "backup": 1,
            "path": backupServerPath,
            "timestamp": `${Math.floor(Date.now() / 1000)}`,
        });
        if (response && !response.ok) {
            const detail = response.status === 405
                ? 'Write access is disabled for this proxy (405 Method Not Allowed).'
                : `Server returned ${response.status}`;
            setBackupError(detail);
            setBackupStarted(false);
            setBackupProgress(-1);
            return;
        }
        setBackupProgress(Math.floor(4 + Math.random() * 10));
        await waitBackup();
    }

    async function waitBackup() {
        let response = await bond.get("/sys/backup");

        if (!response) {
            await sleep(500);
            response = await bond.get("/sys/backup");
            if (!response) {
                setBackupStarted(false);
                setBackupProgress(-1);
                return;
            }
        }

        if (response["progress"] === 1000) {
            setBackupStarted(false);
            setBackupProgress(100);
            onUploadDone(bond.id)
        } else if (response["progress"] === -1) {
            setBackupStarted(false);
            setBackupProgress(-1);
        } else {
            if (response["progress"]) setBackupProgress(response["progress"] / 10);
            setTimeout(waitBackup, 300);
        }
    }

    return (<div className={"backupContent"}>
        <h4><FontAwesomeIcon icon={faCloudArrowUp} className="me-2"/>Create Backup</h4>
        <Button variant="primary" onClick={startBackup} disabled={backupStarted} className={"w-100"}>
            {backupStarted ? <FontAwesomeIcon icon={faSpinner} className="me-2 fa-spin"/> :
                <FontAwesomeIcon icon={faClone} className="me-2"/>}
            Backup {bond.id} Now
        </Button>
        {backupError && (
            <div className={"text-danger small mt-2"}>{backupError}</div>
        )}
        {backupProgress !== 0 && (<>
            <ProgressBar now={Math.max(backupProgress, 0)} variant={backupProgress === -1 ? "danger" : "success"} animated={backupStarted} label={`${backupProgress}%`}
                         className={"m-1 mt-1 mb-1"}/>
        </>)}

    </div>);
}

export default Backup;
